import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'

import { useTypedSelector } from '../../hooks'
import { RoutesTree } from '../../router'

import { Container, TabBlock, TabText, TabsWrapper } from './styled'
import { CategoriesTab } from './CategoriesTab'
import { SubCategoriesTab } from './SubCategoriesTab'
import { useTranslation } from 'react-i18next'
import { AdviceSubCategoriesTab } from './AdviceSubCategoriesTab'

export const Categories: React.FC = () => {
  const { user } = useTypedSelector(state => state.user)
  const [tab, setTab] = useState('1')
  const { t } = useTranslation('categories')

  if (!user?.access?.categories) {
    return <Redirect to={RoutesTree.notFound.path} />
  }

  return (
    <Container>
      <TabsWrapper>
        <TabBlock
          className={tab === '1' ? 'active' : ''}
          onClick={() => setTab('1')}
        >
          <TabText>{t('categories')}</TabText>
        </TabBlock>
        <TabBlock
          className={tab === '2' ? 'active' : ''}
          onClick={() => setTab('2')}
        >
          <TabText>{t('subcategories')}</TabText>
        </TabBlock>
        <TabBlock
          className={tab === '3' ? 'active' : ''}
          onClick={() => setTab('3')}
        >
          <TabText>{t('advice.subcategories')}</TabText>
        </TabBlock>
      </TabsWrapper>
      {tab === '1' && <CategoriesTab />}
      {tab === '2' && <SubCategoriesTab />}
      {tab === '3' && <AdviceSubCategoriesTab />}
    </Container>
  )
}
